import dayjs from 'dayjs';
import weekday from 'dayjs/plugin/weekday';
import moment from 'moment';

dayjs.extend(weekday);

/**
 * @param {*} pastNthWeek {Integer} - represents Past weeks
 * @param {*} fmt {String}
 * @returns {Object} - { startDate: '1/1', endDate: '1/7'}
 * WMT Week starts on Saturday and ends on next Friday
 */
const getPastWMTWeekDateRange = (pastNthWeek = 1, fmt = 'MMM DD, YYYY') => {
	let WEEK_START = -8; // previous Saturday
	const WEEK_END = -2; // Default - previous Friday
	if (pastNthWeek) {
		WEEK_START = WEEK_START - (pastNthWeek - 1) * 7;
	}
	return {
		startDate: dayjs().weekday(WEEK_START).format(fmt),
		endDate: dayjs().weekday(WEEK_END).format(fmt),
	};
};

/**
 *
 * @param {*} fmt {String}
 * @returns @returns {Object} - { startDate: '1/8', endDate: '1/11'}
 * WMT week starts on Saturday and date range would be 'Saturday' to 'Current date - 1'
 */
const getWMTWeekToDate = (fmt = 'MMM DD, YYYY') => {
	const WEEK_START = -1;
	return {
		startDate: dayjs().weekday(WEEK_START).format(fmt),
		endDate: dayjs().subtract(1, 'day').format(fmt),
	};
};

/**
 *
 * @param {*} _d {Moment object}
 * @returns Walmart week no corresponding to the given date
 */

function getWeekNo(_d) {
	const monthIdx = _d.month();
	const currYear = _d.year();
	const prevYear = currYear - 1;
	const appliedYear = monthIdx === 0 ? prevYear : currYear;

	let prevYearEndWkNo = moment()
		.clone()
		.set('year', prevYear)
		.endOf('year')
		.week();

	let currYearStartWekNo = moment()
		.clone()
		.set('year', currYear)
		.startOf('year')
		.week();

	let currYrFebMonthStartWk = moment()
		.clone()
		.set('year', appliedYear)
		.set('date', 1)
		.set('month', 1)
		.week();

	let givenDtWkNo = _d.week();
	let offset = prevYearEndWkNo >= currYearStartWekNo ? 1 : 0;

	let val = givenDtWkNo - currYrFebMonthStartWk + offset;
	if (monthIdx === 0) {
		val = prevYearEndWkNo - currYrFebMonthStartWk + offset;
		if (givenDtWkNo < 52) {
			val += givenDtWkNo;
		}
		if (val > 52) {
			val = 1;
		}
	}
	return val;
}
export { getPastWMTWeekDateRange, getWMTWeekToDate, getWeekNo };
